const northboundHeaders = [
  "Regional Airport - Baggage Claim",
  "Main Street Station - Front Door",
  "Trinidad Community Center - Bus Stop",
  "Downtown Transit Hub - Bus Stop",
  "Southern Colorado Welcome Center - Front Door",
];

const northboundTimes = [
  ["6:00 AM", "7:00 AM", "10:00 AM", "11:00 AM", "11:30 AM", "12:00 PM", "12:30 PM", "1:00 PM", "2:15 PM", "7:30 PM", "8:45 PM", "10:20 PM"],
  ["6:04 AM", "7:04 AM", "10:04 AM", "11:04 AM", "11:34 AM", "12:04 PM", "12:34 PM", "1:04 PM", "2:19 PM", "7:34 PM", "8:49 PM", "10:24 PM"],
  ["6:21 AM", "7:21 AM", "10:21 AM", "11:21 AM", "11:51 AM", "12:21 PM", "12:51 PM", "1:21 PM", "2:36 PM", "7:51 PM", "9:06 PM", "10:41 PM"],
  ["6:25 AM", "7:25 AM", "10:24 PM", "11:24 AM", "11:55 AM", "12:24 PM", "12:55 PM", "1:25 PM", "2:40 PM", "7:55 PM", "9:10 PM", "10:45 PM"],
  ["6:30 AM", "7:30 AM", "10:30 AM", "11:30 AM", "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:45 PM", "8:00 PM", "9:15 PM", "10:50 PM"],
];

const southboundHeaders = [
  "Southern Colorado Welcome Center - Front Door",
  "Visitor Information Center - Bus Stop",
  "Trinidad Community Center - Bus Stop",
  "Main Street Station - Front Door",
  "Arrives At Regional Airport",
];

const southboundTimes = [
  ["5:30 AM", "6:30 AM", "10:30 AM", "11:30 AM", "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "3:00 PM", "8:00 PM", "9:15 PM"],
  ["5:34 AM", "6:34 AM", "10:34 AM", "11:34 AM", "12:04 PM", "12:34 PM", "1:04 PM", "1:34 PM", "3:04 PM", "8:04 PM", "9:19 PM"],
  ["5:37 AM", "6:37 AM", "10:37 AM", "11:37 AM", "12:07 PM", "12:37 PM", "1:07 PM", "1:37 PM", "3:07 PM", "8:07 PM", "9:22 PM"],
  ["5:54 AM", "6:54 AM", "10:54 AM", "11:51 AM", "12:24 PM", "12:54 PM", "1:24 PM", "1:54 PM", "3:24 PM", "8:24 PM", "9:39 PM"],
  ["6:00 AM", "7:00 AM", "11:00 AM", "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "3:30 PM", "8:30 PM", "9:45 PM"],
];

function ScheduleTable({ headers, times, title }: {
  headers: string[];
  times: string[][];
  title: string;
}) {
  return (
    <div className="mb-10 md:mb-14">
      <h4 className="font-heading text-xl sm:text-2xl md:text-3xl font-semibold text-foreground-900 text-center mb-6 md:mb-8">
        {title}
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[900px] border-collapse border border-background-200/70 text-sm">
          <tbody>
            {headers.map((header, rowIdx) => (
              <tr
                key={header}
                className={rowIdx % 2 === 0 ? "bg-background-50" : "bg-background-100"}
              >
                <td className="border border-background-200/70 px-3 py-2.5 md:px-4 md:py-3 font-medium text-foreground-800 whitespace-nowrap">
                  {header}
                </td>
                {times[rowIdx].map((time, colIdx) => (
                  <td
                    key={`${rowIdx}-${colIdx}`}
                    className="border border-background-200/70 px-2 py-2.5 md:px-3 md:py-3 text-center text-foreground-700 whitespace-nowrap"
                  >
                    {time}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function ScheduleTables() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 pb-4 md:pb-8">
        <ScheduleTable
          headers={northboundHeaders}
          times={northboundTimes}
          title="Shuttle from Regional Airport to Trinidad & Surrounding Areas"
        />
        <ScheduleTable
          headers={southboundHeaders}
          times={southboundTimes}
          title="Shuttle from Trinidad & Surrounding Areas to Regional Airport"
        />
      </div>
    </section>
  );
}